import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import '../../../Assets/Css/TaskBoard.scss';
import DatePicker from 'react-datepicker';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import TaskIcon from '../../../Assets/Images/Task/taskicon';
import TaskBoardIcon from '../../../Assets/Images/Task/taskboard';
import TaskCalendarIcon from '../../../Assets/Images/Task/taskcalendar';
import { getTasks, getTaskStatus, updateTask } from '../../../Services/Task/action';
import { connect } from 'react-redux';
import moment from 'moment';
import UserAvatar from 'react-user-avatar';
import { customStyle } from '../../../Components/Style';
import Select from 'react-select';
import { getprojects } from '../../../Services/Project/action';
import Skeleton from 'react-loading-skeleton';

const EmpTaskBoard = (props) => {
    const [activeButton, setActiveButton] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [colorValue, setColorValue] = useState("#ff0000");

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    const changeColor = (e) => {
        setColorValue(e.target.value);
    };

    const changeText = (e) => {
        setColorValue(e.target.value);
    };

    const navigate = useNavigate();
    const location = useLocation();

    const initialState = {
        startdate: null,
        enddate: null,
        projectStatus: null,
        project: null
    };

    const [clientData, setClientData] = useState(initialState);
    const [columns, setColumns] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [isMytaskList, setIsMyTaskList] = useState(false);

    useEffect(() => {
        fetchData();
    }, [location.search]);

    const fetchData = async () => {
        try {
            await props?.getTasks();
            await props?.getTaskStatus();
            await props?.getprojects();
        } catch (error) {
            console.error('Error fetching tasks in task board:', error);
        }
    };

    const Project = props?.project?.map((item) => {
        return {
            label: item?.name,
            value: item?.id
        }
    });


    useEffect(() => {
        if (clientData?.project) {
            applyFilters({
                search: searchTerm,
                startDate: clientData?.startdate,
                endDate: clientData?.enddate,
                project: clientData?.project
            });
        } else {
            updateColumns(props?.task);
        }
    }, [props?.task]);

    const updateColumns = (taskList, projectId = null) => {

        let relevantStatuses;

        if (projectId) {
            relevantStatuses = props?.taskStatus
                ?.filter((status) =>
                    status?.taskStatus?.some((s) => s?.project_id === projectId)
                )
                ?.map((item) => ({
                    name: item?.name,
                    color_code: item?.color_code,
                    createdAt: item?.createdAt
                }));
        }
        else {
            relevantStatuses = []
        }

        const initialColumns = relevantStatuses?.reduce((acc, status) => {
            acc[status?.name] = {
                name: status?.name,
                color_code: status?.color_code,
                createdAt: status?.createdAt,
                items: []
            };
            return acc;
        }, {});

        if (taskList && Array.isArray(taskList)) {
            taskList.forEach(task => {
                const status = task.status || 'incomplete';
                const profilePics = task?.taskUserMap?.map((item) => item?.userTaskMap?.profile_pic) || [];
                const usernames = task?.taskUserMap?.map((item) => item?.userTaskMap?.name) || [];
                if (!initialColumns[status]) return;

                initialColumns[status]?.items.push({
                    id: task.id.toString(),
                    name: task?.title,
                    profile_pic: profilePics,
                    usernames,
                    project: task?.project?.name,
                    originalTask: task,
                    createdAt: initialColumns[status]?.createdAt
                });
            });
        }

        setColumns(initialColumns);
    };


    let path = '/task/emptask/add';
    const ClickAddTask = () => {
        navigate(path);
    };

    useEffect(() => {
        if (location.pathname == '/task/emptask') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        } else if (location.pathname == '/task/emptaskboard') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        } else if (location.pathname == '/task/emptaskcalendar') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        }
    }, []);

    const clickButton = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
    };

    const onDragEnd = async (result) => {
        const { source, destination } = result;

        if (!destination) return;

        if (source.droppableId === destination.droppableId && source.index === destination.index)
            return;

        const sourceColumn = columns[source.droppableId];
        const destinationColumn = columns[destination.droppableId];
        const sourceItems = Array.from(sourceColumn.items);
        const destItems = Array.from(destinationColumn.items);

        const [movedItem] = sourceItems.splice(source.index, 1);

        if (source.droppableId === destination.droppableId) {
            sourceItems.splice(destination.index, 0, movedItem);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems,
                },
            });
        } else {
            destItems.splice(destination.index, 0, movedItem);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems,
                },
                [destination.droppableId]: {
                    ...destinationColumn,
                    items: destItems,
                },
            });
        }

        await props?.updateTask(sourceColumn?.items?.[0]?.id, { status: destinationColumn?.name }, true)

        if (clientData?.project || clientData?.startdate || clientData?.enddate || searchTerm) {
            applyFilters({
                search: searchTerm,
                startDate: clientData?.startdate,
                endDate: clientData?.enddate,
                project: clientData?.project
            });
        } else {
            updateColumns(props?.task);
        }
    };

    const circleStyle = (color) => ({
        display: 'inline-block',
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: '15px',
    });

    const applyFilters = ({ search, startDate, endDate, project }) => {
        const filtered = props?.task?.filter((task) => {
            let matchesSearch = true;
            let matchesDate = true;
            let matchesProject = true;

            const taskTitle = task?.title?.toLowerCase() || '';

            if (startDate && endDate) {
                const itemStartDate = moment(task?.start_date, 'YYYY-MM-DD').startOf('day').toDate();
                const itemDueDate = task?.due_date
                    ? moment(task?.due_date, 'YYYY-MM-DD').endOf('day').toDate()
                    : itemStartDate;

                const filterStart = moment(startDate).startOf('day').toDate();
                const filterEnd = moment(endDate).endOf('day').toDate();

                matchesDate =
                    (itemStartDate >= filterStart && itemStartDate <= filterEnd) ||
                    (itemDueDate >= filterStart && itemDueDate <= filterEnd);
            }
            if (search) {
                matchesSearch = taskTitle.includes(search.toLowerCase());
            }

            if (project) {
                matchesProject = task?.project?.id === project?.value;
            }
            return matchesSearch && matchesDate && matchesProject;
        });

        updateColumns(filtered, project?.value || null);
    };

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setSearchTerm(value);
        setClientData((preVal) => ({
            ...preVal,
            [name]: value,
        }));

        applyFilters({ search: value, startDate: clientData?.startdate, endDate: clientData?.enddate, project: clientData?.project });
    };

    const handleClear = () => {
        setClientData({
            projectStatus: "",
            searchTerm: "",
            employeename: "",
            startdate: "",
            enddate: "",
            project: ""
        });
        setSearchTerm("");
        setIsMyTaskList(false);
        updateColumns(props?.task);
    };

    const handleFetchUserTasks = () => {
        setIsMyTaskList(true);
        const userTasks = props?.task?.filter((task) =>
            task?.taskUserMap?.some((item) => item?.userTaskMap?.id === props?.user?.id && task?.project?.id == clientData?.project?.value)
        );
        updateColumns(userTasks, clientData?.project?.value || null);
    };

    return (
        <>
            <div className="taskboard-main">
                <div className="page-title" style={{ padding: '0px' }}>
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width={200} height={40} />
                        ) : (
                            <h4> Task Board </h4>
                        )
                    }
                    {
                        props.loading ? (
                            <Skeleton className='badge rounded-pill' width={100} height={40} />
                        ) : (
                            <button
                                className="custom-taskboard-btn"
                                disabled={props.loading}
                                onClick={ClickAddTask}
                            >
                                Add Task
                            </button>
                        )
                    }
                </div>
                <div className="row">

                    <div className="col-lg-2">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <h6 className="label">Start Date</h6>
                                    <DatePicker
                                        selected={clientData?.startdate ? new Date(clientData?.startdate) : null}
                                        onChange={(date) => {
                                            const formattedDate = date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                .toISOString()
                                                .split('T')[0] : null;
                                            const currentEndDate = clientData?.enddate

                                            setClientData((preVal) => ({
                                                ...preVal,
                                                startdate: formattedDate,
                                            }));

                                            if (formattedDate && currentEndDate) {
                                                applyFilters({
                                                    search: searchTerm,
                                                    startDate: new Date(formattedDate),
                                                    endDate: new Date(currentEndDate),
                                                    project: clientData?.project,
                                                });
                                            }
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Start Date"
                                        name="transaction_date"
                                        disabled={props.loading}
                                        customInput={<input className="input-css" />}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#5757fe',
                                                primary: '#5757fe',
                                            },
                                        })}
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className="col-lg-2">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <h6 className="label">End Date</h6>
                                    <DatePicker
                                        selected={clientData.enddate ? new Date(clientData.enddate) : null}
                                        onChange={(date) => {
                                            const formattedDate = date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                .toISOString()
                                                .split('T')[0] : null; const updatedClientData = {
                                                    ...clientData,
                                                    enddate: formattedDate
                                                };
                                            const currentStartDate = clientData?.startdate

                                            setClientData((preVal) => ({
                                                ...preVal,
                                                enddate: formattedDate,
                                            }));

                                            if (currentStartDate && formattedDate) {
                                                applyFilters({
                                                    search: searchTerm,
                                                    startDate: new Date(currentStartDate),
                                                    endDate: new Date(formattedDate),
                                                    project: clientData?.project,
                                                });
                                            }
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="End Date"
                                        name="transaction_date"
                                        disabled={props.loading}
                                        customInput={<input className="input-css" />}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#5757fe',
                                                primary: '#5757fe',
                                            },
                                        })}
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className="col-lg-3">
                        <div className="input-group">
                            <h6 className="label">Search</h6>
                            <input
                                type="text"
                                className="input-css"
                                name="employeename"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={searchFiled}
                            />
                        </div>
                    </div>

                    <div className="col-lg-3">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <h6 className="label">Projects</h6>
                                    <Select
                                        options={Project}
                                        styles={{
                                            ...customStyle,
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 2,
                                            }),
                                        }}
                                        value={clientData?.project}
                                        placeholder="Projects"
                                        onChange={(val) => {

                                            setClientData((preVal) => ({
                                                ...preVal,
                                                project: val,
                                            }));

                                            applyFilters({
                                                search: searchTerm,
                                                startDate: clientData?.startdate,
                                                endDate: clientData?.enddate,
                                                project: val
                                            });
                                        }}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#5757fe',
                                                primary: '#5757fe',
                                            },
                                        })}
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className='col-lg-1'>

                        {(searchTerm || isMytaskList || clientData?.enddate || clientData?.startdate || clientData?.project) && (
                            props.loading ? (
                                <Skeleton className='badge rounded-pill' width="100%" height={40} />
                            ) : (
                                <button
                                    className="custom-taskboard-btn"
                                    disabled={props.loading}
                                    style={{ marginTop: '34px' }}
                                    onClick={handleClear}
                                >
                                    Clear
                                </button>
                            )
                        )}
                    </div>
                </div>

                <div className="gap-4 taskboard-export-btn">
                    <div>
                        {
                            props.loading ? (
                                <Skeleton className='badge rounded-pill' width={100} height={40} />
                            ) : (
                                <button
                                    className="custom-taskboard-btn"
                                    disabled={props.loading}
                                    onClick={openModal}
                                >
                                    Add Status Column
                                </button>
                            )
                        }

                        {
                            props.loading ? (
                                <Skeleton className='badge rounded-pill' width={100} height={40} />
                            ) : (
                                <button className="custom-taskboard-btn" disabled={props.loading} onClick={handleFetchUserTasks}>
                                    {props.loading ? (
                                        <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                                    ) : (
                                        'My Task'
                                    )}
                                </button>
                            )
                        }

                    </div>

                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width={50} height={40} />
                        ) : (
                            <div className="navigation_btn">
                                <button
                                    className={`btn1 ${activeButton === 'emptask' ? 'active' : ''}`}
                                    onClick={() => clickButton('emptask', '/task/emptask')}
                                >
                                    <TaskIcon
                                        color={activeButton === 'emptask' ? 'white' : 'black'}
                                        bgColor={activeButton === 'emptask' ? 'black' : 'white'}
                                    />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === 'emptaskboard' ? 'active' : ''}`}
                                    onClick={() => clickButton('emptaskboard', '/task/emptaskboard')}
                                >
                                    <TaskBoardIcon
                                        color={activeButton === 'emptaskboard' ? 'white' : 'black'}
                                        bgColor={activeButton === 'emptaskboard' ? 'black' : 'transparent'}
                                    />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === 'emptaskcalendar' ? 'active' : ''}`}
                                    onClick={() => clickButton('emptaskcalendar', '/task/emptaskcalendar')}
                                >
                                    <TaskCalendarIcon
                                        color={activeButton === 'emptaskcalendar' ? 'white' : 'black'}
                                        bgColor={activeButton === 'emptaskcalendar' ? 'black' : 'white'}
                                    />
                                </button>
                            </div>
                        )
                    }
                </div>
            </div >

            <div className="drag-drop-div mb-5">
                {Object.entries(columns)?.length == 0 ? (
                    <div className="no-records">
                        <p style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100px",
                            width: '1000px',
                            textAlign: "center",
                            color: "#777",
                            fontSize: "20px",
                            fontWeight: "500",
                        }}>
                            No records, Please select a project
                        </p>
                    </div>
                ) : (
                    <DragDropContext onDragEnd={onDragEnd}>
                        {Object.entries(columns)?.sort(([, a], [, b]) => new Date(a.createdAt) - new Date(b.createdAt)).map(([columnId, column]) => (
                            <Droppable droppableId={columnId} key={columnId}>
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        className="drag-drop-droppable"
                                    >
                                        <h6 className="col-name">
                                            {<span style={circleStyle(column.color_code)}></span>}
                                            {column.name}
                                        </h6>
                                        <div className="card_main">
                                            {column.items.map((item, index) => (
                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                    {(provided) => (
                                                        <div
                                                            className="card"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                                ...provided.draggableProps.style,
                                                            }}
                                                        >
                                                            <p className="card_title">{item?.name}</p>
                                                            <div className="card_badge"></div>
                                                            <div className='project'>

                                                                <svg class="svg-inline--fa fa-layer-group fa-w-16 f-11 text-lightest" width={20} height={20} aria-hidden="true" focusable="false" data-prefix="fa" data-icon="layer-group" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="rgb(179, 177, 177)" d="M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"></path></svg>
                                                                <div className='project-name'>{item?.project}</div>
                                                            </div>
                                                            <div className="card_footer">
                                                                {/* <div className="card_icons">
                                                                <img src={Bookmark} className=" bookmark" />
                                                                <img src={DoubleArrowUp} className=" doubleup" />

                                                                <div className=" upvote">2</div>
                                                            </div> */}
                                                                <div className="card_icons">
                                                                    <div className="card__id">
                                                                        <span>{`CD_${item?.id}`}</span>
                                                                    </div>
                                                                    <div className="card__status">
                                                                        {Array.isArray(item?.profile_pic) && item.profile_pic.some(pic => pic?.data) ? (
                                                                            item?.profile_pic?.map((pic, index) => {
                                                                                if (pic?.data) {
                                                                                    const profilePicSrc = `data:image/png;base64,${btoa(
                                                                                        String.fromCharCode(...new Uint8Array(pic?.data))
                                                                                    )}`;
                                                                                    return (
                                                                                        <>
                                                                                            <img key={index} src={profilePicSrc} alt="User" className="card__status-profile_pic" />
                                                                                            <span className="card__status-dot"></span>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                                return null;
                                                                            })
                                                                        ) : (
                                                                            <>
                                                                                {Array.isArray(item?.usernames) && item?.usernames?.length > 0 ? (
                                                                                    item?.usernames?.map((name, index) => (
                                                                                        <span key={index} className="card__status-initials">
                                                                                        {name?.split(" ").length === 1 ? name?.substring(0, 2).toUpperCase() : name?.split(" ")?.map(word => word[0]).join("").toUpperCase()}
                                                                                        </span>
                                                                                    ))
                                                                                ) : (
                                                                                    <span className="initials">N/A</span>
                                                                                )}
                                                                                <span className="card__status-dot"></span>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                        </div>
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        ))}
                    </DragDropContext>
                )}
            </div>

            <Modal
                show={showModal}
                onHide={closeModal}
                centered
                dialogClassName="custom-status-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="custom-statusmodal-title">
                        Add Status Column
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="custom-statusmodal-body">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="input-group">
                                <h6 className="label">Column Name</h6>
                                <input
                                    type="text"
                                    className="input-css"
                                    name="title"
                                    placeholder="---"
                                    onChange={searchFiled}
                                />
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="input-group" style={{ position: 'relative' }}>
                                <h6 className="label">Label Color</h6>
                                <input
                                    type="text"
                                    className="input-css"
                                    name="title"
                                    placeholder="Color"
                                    value={colorValue}
                                    onChange={changeText}
                                />
                                <input
                                    type="color"
                                    className="color-picker"
                                    style={{
                                        position: 'absolute',
                                        right: '0px',
                                        top: '73%',
                                        transform: 'translateY(-50%)',
                                        height: '43px',
                                        width: '43px',
                                        padding: '10px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        backgroundColor: '#bfbfbf',
                                    }}
                                    onChange={changeColor}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={closeModal}
                        className="btn-cancel"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={closeModal}
                        className="btn-confirm"
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.taskReducer.loading,
        task: state.taskReducer.task,
        user: state.authenticationReducer.user,
        taskStatus: state.taskReducer.taskStatus,
        project: state.projectReducer.project
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getTasks: () => {
            dispatch(getTasks())
        },
        updateTask: (id, data, showToast) => {
            dispatch(updateTask(id, data, showToast))
        },
        getTaskStatus: () => {
            dispatch(getTaskStatus())
        },
        getprojects: () => {
            dispatch(getprojects())
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EmpTaskBoard);
